import React, { Component, Fragment } from "react";
import { Row, Col, Container, Image } from "react-bootstrap";

import styles from "./Founders.module.scss";

import Raffaella from "../../assets/png/Raffaella.png";
import Rafik from "../../assets/png/Rafik.png";
import Roshdy from "../../assets/png/Roshdy.png";

export default class Founders extends Component {
  render() {
    return (
      <section id={styles.Founders}>
        <Container id="Founders" fluid>
          <Row>
            <Col xl={6} className={styles.containerTop}>
              <div className={styles.vl}></div>
              <div id={styles.Content}>
                <p id={styles.SubHeader}>OUR STORY</p>
                <br></br>
                <p id={styles.Header}>Meet the Founders</p>
                <br></br>
                <p id={styles.ContentText}>
                  A little peak into what drives our passion for
                  environmentally-sustainable products and ways of life.
                </p>
              </div>
              <div id={styles.RoshdyBox}>
                <Image
                  src={Roshdy}
                  id={styles.Roshdy}
                ></Image>
                <p className={styles.name}>ROSHDY RADY</p>
                <p className={styles.role}>
                  <i>President & CEO,</i> Lead Scientist & Soil Chemistry and
                  Fertility Specialist
                </p>
                <p className={styles.info}>
                  Holding a Bachelor of Agriculture and Post-Graduate Degree in
                  Soil Chemistry from Minya University in Al-Minya, Egypt,
                  Roshdy's lifelong passion is combating climate change via
                  easily integratable processes, before we start to see its
                  serious effects. <br></br>
                  <br></br>His previous experience working for Agriculture and
                  Agri-Food Canada as a soil scientist, investigating and
                  solving critical soil mysteries for the department, propelled
                  him to pursue his passion for climate change, plant health,
                  and farming innovation.
                </p>
                <i>
                  <a
                    className={styles.email}
                    href={"mailto:" + `roshdy@agrinolinc.com`}
                  >
                    roshdy@agrinolinc.com
                  </a>
                </i>
              </div>
            </Col>
            <Col xl={6} className={styles.containerBottom}>
              <div id={styles.RafikBox}>
                <Image
                  src={Rafik}
                  id={styles.Rafik}
                ></Image>
                <p className={styles.name}>RAFIK RADY</p>
                <p className={styles.role}>
                  <i>Vice President,</i> Director of Research & Development
                </p>
                <p className={styles.info}>
                  With a Bachelor of Aerospace Engineering, specialization in
                  Composite Materials from Carleton University, Rafik's passion
                  for finding simple, elegant solutions to complex problems
                  drove his desire for leading the design of next-generation,
                  environmentally-sustainable products. <br></br>
                  <br></br> His diverse experience in complex design, 3D
                  modelling, data analysis, manufacturing techniques, and
                  extensive testing methodologies serve as a backbone for his
                  role in researching and developing Agrinol's products.
                </p>
                <i>
                  <a
                    className={styles.email}
                    href={"mailto:" + `rafik@agrinolinc.com`}
                  >
                    rafik@agrinolinc.com
                  </a>
                </i>
              </div>
              <div id={styles.RaffaellaBox}>
                <Image
                  src={Raffaella}
                  id={styles.Raffaella}
                ></Image>
                <p className={styles.name}>RAFFAELLA RADY</p>
                <p className={styles.role}>
                  Director of Communications & Marketing
                </p>
                <p className={styles.info}>
                  Raffaella's passion for communications and environmental
                  issues roots from her Bachelor of Social Sciences: Honours
                  Specialization in Sociology and Minor in Philosophy, from the
                  University of Ottawa. It has also shaped her 6+ years of
                  experience working for various governmental departments and
                  blogging about the symptoms of climate change impacting us
                  globally. <br></br>
                  <br></br>She manages all things content, social media, website
                  design, media relations, and internal and external messaging,
                  bringing the most crucial information directly to your
                  fingertips.
                </p>
                <i>
                  <a
                    className={styles.email}
                    href={"mailto:" + `raffaella@agrinolinc.com`}
                  >
                    raffaella@agrinolinc.com
                  </a>
                </i>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    );
  }
}
